import { AuthModal } from '@components/App/Auth/AuthModal'
import ForgotPassword from '@components/App/Auth/ForgotPassword/ForgotPassword'
import { PasswordReset } from '@components/App/Auth/PasswordReset'
import { VerifyEmail } from '@components/App/Auth/VerifyEmail/VerifyEmail'
import { DeleteAccount } from '@components/App/Modal/DeleteAccount'
import { MultipleSitemap } from '@components/App/Modal/Import/components/Tabs/SitemapTab/Modals/MultipleSitemap'
import { TransferProject } from '@components/App/Modal/TransferProject'

import { SetupAccount } from '../Auth/SetupAccount'
import { Pricing } from '../Subscribe'
import * as Survey from '../Survey'
import GenerateNewProjectModal from './Actions/GenerateNewProjectModal'
import NewModal from './Actions/New'
import { ApiKeyCreated } from './ApiKeyCreated'
import { BlockModal } from './BlockModal'
import { ChangeEmailOtp } from './ChangeEmailOtp'
import { CreateApiKey } from './CreateApiKey'
import * as ModalTypes from './constants'
import { ExportAsCsv } from './ExportAsCsv'
import { ExportAsFigma } from './ExportAsFigma'
import { ExportAsPng } from './ExportAsPng'
import { ExportAsPrompt } from './ExportAsPrompt'
import { ExportAsSitemapXml } from './ExportAsSitemapXml'
import { ExportAsWp } from './ExportAsWp'
import { ExportAsXml } from './ExportAsXml'
import { ExportSeoAsCode } from './ExportSeoAsCode'
import { FolderVisibility } from './FolderVisibility'
import { Ga4PropertyModal } from './Ga4PropertyModal'
import {
  CrawlerError,
  CrawlerLoading,
  Import,
  ImportSelectUrls,
  Report,
} from './Import'
import { Integrations } from './Integrations'
import { LeaveFeedback } from './LeaveFeedback'
import { NodeGalleryFigmaLink } from './NodeGalleryFigmaLink'
import { PageContentView } from './PageContentView'
import { PlanUpdated, PlanUpdatedTeam } from './PlanUpdated'
import ProjectInformationModal from './ProjectInformation/Modal'
import { ProjectNotifications } from './ProjectNotifications'
import { PublishModal } from './PublishModal'
import { SaveAsTemplate } from './SaveAsTemplate'
import { ScheduleCrawl } from './ScheduleCrawl'
import { SeoPreview } from './SeoPreview'
import { Share } from './Share'
import { SymbolModal } from './SymbolModal'
import { UpgradePlanModal } from './UpgradePlanModal'

export default {
  [ModalTypes.MODAL_SHARE]: Share,
  [ModalTypes.MODAL_SCHEDULE_CRAWL]: ScheduleCrawl,
  [ModalTypes.MODAL_PRICING]: Pricing,

  [ModalTypes.MODAL_AUTH]: AuthModal,
  [ModalTypes.MODAL_AUTH_VERIFY_EMAIL]: VerifyEmail,
  [ModalTypes.MODAL_AUTH_SETUP_ACCOUNT]: SetupAccount,
  [ModalTypes.MODAL_AUTH_FORGOT_PASSWORD]: ForgotPassword,
  [ModalTypes.MODAL_AUTH_RESET_PASSWORD]: PasswordReset,

  [ModalTypes.MODAL_EXPORT_PNG]: ExportAsPng,
  [ModalTypes.MODAL_EXPORT_XML]: ExportAsXml,
  [ModalTypes.MODAL_EXPORT_CSV]: ExportAsCsv,
  [ModalTypes.MODAL_EXPORT_SITEMAP]: ExportAsSitemapXml,
  [ModalTypes.MODAL_EXPORT_FIGMA]: ExportAsFigma,
  [ModalTypes.MODAL_EXPORT_WP]: ExportAsWp,
  [ModalTypes.MODAL_BLOCK]: BlockModal,
  [ModalTypes.MODAL_SYMBOL]: SymbolModal,
  [ModalTypes.MODAL_BLOCK_CONTENT_VIEW]: PageContentView,
  [ModalTypes.SURVEY_CANCEL]: Survey.Cancel,
  [ModalTypes.IMPORT_PROJECT]: Import,
  [ModalTypes.MODAL_REPORT_PROJECT]: Report,
  [ModalTypes.IMPORT_SELECT_URLS]: ImportSelectUrls,
  [ModalTypes.IMPORT_PROJECT_CRAWLER_LOADING]: CrawlerLoading,
  [ModalTypes.IMPORT_PROJECT_CRAWLER_ERROR]: CrawlerError,
  [ModalTypes.IMPORT_PROJECT_MULTIPLE_SITEMAPS]: MultipleSitemap,
  [ModalTypes.MODAL_PROJECT_INFORMATION]: ProjectInformationModal,
  [ModalTypes.MODAL_LEAVE_FEEDBACK]: LeaveFeedback,
  [ModalTypes.MODAL_INTEGRATIONS]: Integrations,
  [ModalTypes.MODAL_GA4_PROPERTY]: Ga4PropertyModal,
  [ModalTypes.MODAL_NEW]: NewModal,
  [ModalTypes.MODAL_NEW_GENERATE_PROJECT]: GenerateNewProjectModal,
  [ModalTypes.MODAL_FOLDER_VISIBILITY]: FolderVisibility,
  [ModalTypes.MODAL_SAVE_AS_TEMPLATE]: SaveAsTemplate,
  [ModalTypes.MODAL_PLAN_UPGRADE_SUCCESSFUL]: PlanUpdated,
  [ModalTypes.MODAL_TEAM_UPGRADE_SUCCESSFUL]: PlanUpdatedTeam,
  [ModalTypes.MODAL_PLAN_DOWNGRADED]: PlanUpdated,
  [ModalTypes.MODAL_PLAN_CHURN]: PlanUpdated,
  [ModalTypes.MODAL_NODE_GALLERY_FIGMA_LINK]: NodeGalleryFigmaLink,
  [ModalTypes.MODAL_PUBLISH]: PublishModal,
  [ModalTypes.MODAL_DELETE_ACCOUNT]: DeleteAccount,
  [ModalTypes.SEO_EXPORT_AS_CODE]: ExportSeoAsCode,
  [ModalTypes.SEO_PREVIEW]: SeoPreview,

  [ModalTypes.MODAL_PROJECT_TRANSFER]: TransferProject,
  [ModalTypes.MODAL_PROJECT_NOTIFICATIONS]: ProjectNotifications,
  [ModalTypes.MODAL_UPGRADE_PLAN]: UpgradePlanModal,
  [ModalTypes.MODAL_EXPORT_PROMPT]: ExportAsPrompt,

  [ModalTypes.MODAL_CREATE_API_KEY]: CreateApiKey,
  [ModalTypes.MODAL_API_KEY_CREATED]: ApiKeyCreated,

  [ModalTypes.MODAL_CHANGE_EMAIL_OTP]: ChangeEmailOtp,
}
